let images = {};
if (process.env.NODE_ENV === 'development') {
  images.piastrix = require('../imgs/payment-piastrix-icon.svg');
  images.qiwi = require('../imgs/payment-qiwi-icon.svg');
  images.payaneer = require('../imgs/payment-payaneer-icon.svg');
  images.pm = require('../imgs/payment-pm-icon.svg');
  images.adcash = require('../imgs/payment-adcash-icon.svg');
  images.nix = require('../imgs/payment-nix-icon.svg');
  images.beeline = require('../imgs/payment-beeline-icon.svg');
  images.mts = require('../imgs/payment-mts-icon.svg');
  images.megafon = require('../imgs/payment-megafon-icon.svg');
  images.tele2 = require('../imgs/payment-tele2-icon.svg');
  images.sberbank = require('../imgs/payment-sberbank-icon.svg');
  images.alpha = require('../imgs/payment-alpha-icon.svg');
  images.atm = require('../imgs/payment-atm-icon.svg');
  images.bitcoin = require('../imgs/payment-bitcoin-icon.svg');
}

export function getPmImgSrc(pmId) {
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_PM_IMG_TEMPLATE.replace('{}', pmId);
  }

  switch (pmId) {
    case '1':
      return images.piastrix;
    case '2':
      return images.qiwi;
    case '3':
      return images.payaneer;
    case '4':
      return images.pm;
    case '5':
      return images.adcash;
    case '6':
      return images.nix;
    case '7':
      return images.beeline;
    case '8':
      return images.mts;
    case '9':
      return images.megafon;
    case '10':
      return images.tele2;
    case '11':
      return images.sberbank;
    case '12':
      return images.alpha;
    case '13':
      return images.atm;
    case '14':
      return images.bitcoin;
    case '15':
      return images.piastrix;
    default:
      return images.piastrix;
  }
}
